import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DTypeFormTextField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { DTypeFormFieldComponent } from '../../dtype-field.model';
import { TranslocoModule } from '@ngneat/transloco';
import { LocalizePipe } from '../../../pipes/standalone/localize.pipe';

@Component({
    selector: 'text-field-component',
    templateUrl: './text-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, LocalizePipe, FormsModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, TranslocoModule]
})
export class DtypeTextFieldComponent implements DTypeFormFieldComponent, OnInit, OnDestroy {

    @Input() field: DTypeFormTextField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    showPassword = false;

    private unsubscribe = new Subject<void>();

    constructor() { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
        if (this.field.transform && this.field.transform !== 'NONE') {
            this.field.control.valueChanges
                .pipe(
                    takeUntil(this.unsubscribe),
                    distinctUntilChanged()
                )
                .subscribe((value: string) => {
                    if (value) {
                        if (this.field.transform === 'UPPERCASE') {
                            value = value.trim().toUpperCase();
                            this.field.control.setValue(value, { emitEvent: false });
                        } else if (this.field.transform === 'LOWERCASE') {
                            value = value.trim().toLowerCase();
                            this.field.control.setValue(value, { emitEvent: false });
                        }
                    }
                });
        }
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

}
